<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-2" id="_idContainer009">
<p class="dedication"><em class="italic">This book is for the Holdsworths of Sunset House</em></p>
<p class="dedication-space-before"><em class="italic">In Memory of Richard (May 26, 1950–November 28, 2007)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HowMidsummerNight.vue?47e519ea